export enum Response {
  Create,
  Submit,
  Accept,
  Reject,
  AutoReject,
  Override,
  Updated,
  SaveAsDraftForAll
}
